import type { ReactNode } from "react";
import {
  FilterSearchCombobox,
  useSearchDraft,
  type FilterSearchCandidate,
} from "@/components/filter";

export type LabelSearchFieldProps = {
  // 커밋된 텍스트 검색어(URL 소유). 초안은 이 컴포넌트 안에서 가진다.
  search: string;
  onSearchCommit: (search: string) => void;
  candidates: readonly FilterSearchCandidate[];
  // 이미 적용된 라벨 조건(`key:value`). 후보에서 뺀다.
  appliedValues: ReadonlySet<string>;
  // 후보 선택. 부모가 조건을 더하고 검색을 비운다(URL 갱신 한 번).
  onSelectCandidate: (tokenValue: string) => void;
  loading: boolean;
  // 후보 카탈로그를 받지 못했고 표시할 후보가 없을 때의 문구.
  errorMessage?: string;
};

/**
 * 라벨 카탈로그의 검색 콤보박스. Datasets 와 같은 `FilterSearchCombobox` 에 초안/커밋 분리만
 * 추가한다.
 * - 입력은 텍스트 검색이다(300ms 뒤 커밋). Enter 는 즉시 커밋한다.
 * - 후보를 고르면 `key:value` 조건이 되고 입력은 비워진다. 후보를 찾던 글자가 텍스트 검색으로
 *   남지 않게 한다.
 */
export function LabelSearchField({
  search,
  onSearchCommit,
  candidates,
  appliedValues,
  onSelectCandidate,
  loading,
  errorMessage,
}: LabelSearchFieldProps): ReactNode {
  const { draft, change, commitNow, discard } = useSearchDraft(search, onSearchCommit);
  return (
    <FilterSearchCombobox
      value={draft}
      onValueChange={change}
      onSearch={commitNow}
      candidates={candidates}
      appliedValues={appliedValues}
      loading={loading}
      errorMessage={errorMessage}
      placeholder="라벨을 검색하거나 조건을 골라 주세요."
      ariaLabel="라벨 검색"
      onSelectCandidate={(candidate) => {
        discard();
        onSelectCandidate(candidate.value);
      }}
    />
  );
}
